// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"3d6c87d8","368":"e557cb93"}[chunkId] + ".chunk.css";
};